import React from "react";
import styled, { css, ThemeProvider } from "styled-components";
import breakpoint from "styled-components-breakpoint";

import GlobalStyles from "components/GlobalStyles";
import Footer from "components/Footer";
import SideMenu from "components/SideMenu";
import Menu from "components/Menu";
import ScrollTop from "components/ScrollTop";
import { lightTheme, darkTheme } from "components/Themes";
import Toggle from "components/Toggle";
import useWindowSize from "hooks/useWindowSize";
import useDarkMode from "hooks/useDarkMode";

function Layout({
  children,
  fullWidth = false,
}: {
  children: React.ReactNode;
  fullWidth?: boolean;
}) {
  const [width] = useWindowSize();
  const isMobile = width < 768;
  const [theme, toggleTheme] = useDarkMode();

  return (
    <ThemeProvider theme={theme === "light" ? lightTheme : darkTheme}>
      <GlobalStyles />
      <Container>
        {width < 768 ? (
          <SideMenu
            pageWrapId="page-wrap"
            outerContainerId="App"
            selectedTheme={theme}
          />
        ) : (
          <Menu />
        )}
        <Toggle theme={theme} toggleTheme={toggleTheme} />
        <Main fullWith={!isMobile && fullWidth}>{children}</Main>
        <Footer />
        <ScrollTop />
      </Container>
    </ThemeProvider>
  );
}

const Container = styled.div.attrs({ id: "App" })``;

const Main = styled.main`
  padding-top: 4rem;
  max-width: 42rem;
  min-height: 80vh;
  margin: auto;
  justify-content: center;

  ${({ fullWith }: { fullWith?: boolean }) =>
    fullWith &&
    css`
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      max-width: 100%;
    `};

  ${breakpoint("tablet")`
    padding: 5.5rem 2rem 1rem 2rem;
  `}
`;

export default Layout;
